enum FundTransactionStatus {
  SETTLED = 'SETTLED',
  UNKNOWN = 'UNKNOWN',
}

export default FundTransactionStatus;
